export const UPDATE_VEHICLE_INFO = "UPDATE_VEHICLE_INFO";

export function updateVehicleInfo(data){
    return { type: UPDATE_VEHICLE_INFO, payload: data};
}
